import useFormContext from "./useFormAdminContext.js";
import axios from "axios";
import { useEffect, useState } from "react";
import "./SurveyResponse.css";
import { EVENT_SURVEY_QUESTIONS } from '../ApiDetails.js';

const SurveyResponse = () => {
  const { eventFormData } = useFormContext();
  const [surveyQuestionData, setSurveyQuestionData] = useState([]);
  const [values, setValues] = useState([]);
  const [responses, setResponses] = useState([]);

  useEffect(() => {
    getSurveyQuestions();
  }, [eventFormData]);

  useEffect(() => {
    const getSurvey = async () => {
      const eventId = eventFormData?.eventId;
      const apiUrl = `${EVENT_SURVEY_QUESTIONS}/${eventId}`;
      const response = await axios.get(apiUrl);
      setResponses(response.data);
    };
    getSurvey();
  }, [eventFormData]);

  const getSurveyQuestions = async () => {
    if (eventFormData.mltEvent) {
      const questionApi = await axios.get(EVENT_SURVEY_QUESTIONS);
      setSurveyQuestionData(questionApi.data);
      setValues(questionApi.data.map(() => Array(5).fill(0)));
    }
  };

  const handleInputChange = (questionIndex, labelIndex, e) => {
    const inputValue = Math.max(0, Number(e.target.value));
    const newValues = [...values];
    newValues[questionIndex][labelIndex] = inputValue;
    setValues(newValues);
  };

  const getBarColor = (labelIndex) => {
    if (labelIndex === 0) return "#1a40aa";
    if (labelIndex === 1) return "#15cbc6";
    if (labelIndex === 2) return "#faeb05";
    if (labelIndex === 3) return "#a466e0";
    if (labelIndex === 4) return "#f88d00";
    return "#4caf50";
  };

  const handleSave = async () => {
    const postData = surveyQuestionData.map((question, questionIndex) => ({
      responseID: 0,
      eventID: eventFormData.eventId,
      questionID: question.questionId,
      stronglyAgree: values[questionIndex][0],
      agree: values[questionIndex][1],
      neutral: values[questionIndex][2],
      disagree: values[questionIndex][3],
      stronglyDisagree: values[questionIndex][4],
    }));

    try {
      await axios.post(EVENT_SURVEY_QUESTIONS, postData);
      alert("Response saved successfully");
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  useEffect(() => {
    if (responses.length > 0) {
      const updatedValues = responses.map((response) => [
        response.stronglyAgree || 0,
        response.agree || 0,
        response.neutral || 0,
        response.disagree || 0,
        response.stronglyDisagree || 0,
      ]);
      setValues(updatedValues);
    }
  }, [responses]);

  return (
    <div className="container bg-light rounded p-2 mt-2 mb-1">
      <div>
        <h4 className="pagetitle">Survey Responses</h4>
        <button
          type="button"
          className="btn btn-save p-2"
          style={{ float: "right" }}
          onClick={handleSave}
        >
          SAVE
        </button>
      </div>
      <div className="row gx-2">
        {surveyQuestionData.map((question, questionIndex) => (
          <div key={questionIndex} className="col">
            <p
              style={{ paddingTop: "7px", fontSize: "12px", color: "#0000a0" }}
            >
              <b>Question {questionIndex + 1}:</b> {question.questiontext}
            </p>
            <div className="main-container">
              {[
                "Strongly agree",
                "Agree",
                "Neutral",
                "Disagree",
                "Strongly disagree",
              ].map((label, labelIndex) => {
                const backgroundSize = Math.min(
                  values[questionIndex][labelIndex] / 5,
                  100
                );
                const fontColor = backgroundSize > 10 ? "white" : "black";
                return (
                  <div
                    key={labelIndex}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <label style={{ flex: "1" }}>{label}</label>
                    <input
                      type="text"
                      value={values[questionIndex][labelIndex] || ""}
                      onChange={(e) =>
                        handleInputChange(questionIndex, labelIndex, e)
                      }
                      className="input-bar"
                      style={{
                        flex: "1",
                        borderRadius: "5px",
                        padding: "7px",
                        border: "none",
                        fontWeight: "bold",
                        color: fontColor,
                        backgroundImage: `linear-gradient(to right, ${getBarColor(
                          labelIndex
                        )}, ${getBarColor(labelIndex)})`,
                        backgroundSize: `${backgroundSize}% 100%`,

                        backgroundRepeat: "no-repeat",
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SurveyResponse;